/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Following_UnfollowInputs */

const en_following_unfollow = /** @type {(inputs: Following_UnfollowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unfollow ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Unfollow {reference}" |
*
* @param {Following_UnfollowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_unfollow = /** @type {((inputs: Following_UnfollowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_UnfollowInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_unfollow(inputs)
});